import { useMutation, UseMutationResult } from 'react-query'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../utils/alert'
import { localConfig } from '../../../Configs/localConfig'
import { api } from '../../api'

interface PropsPutAdjuvantes {
  cod: number
  propriedades_remover?: number[]
  doses_remover?: number[]
  ativos_remover?: number[]
  refetch: Function
}

export const usePutRemoverDose = (): {
  carregando_remover_dose: boolean
  mutate_remover_dose: (params: PropsPutAdjuvantes) => void
  isSuccess_remover_dose: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPutAdjuvantes> = useMutation(
    async (params: PropsPutAdjuvantes) => {
      const { cod, propriedades_remover, doses_remover, ativos_remover, refetch } = params

     propriedades_remover?.length <= 0 &&  loadingAlert({ msg: 'Removendo...', id: 'remove_ativo' })

      return api
        .post(`/recomendacao/adjuvante/${cod}?codConta=${localConfig()?.conta}`, {
          propriedades_remover: propriedades_remover,
          doses_remover: doses_remover,
          ativos_remover: ativos_remover,
        })
        .then((response: any) => {
           doses_remover.length > 0 && successAlert('Dose cultura removido com sucesso!', 5000, 'remove_ativo')
          refetch?.()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
           error.response.data.error.forEach((data) => {
              doses_remover.length > 0 && errorAlert(data?.msg[0] ?? 'Falha ao remover dose cultura!', 5000, 'remove_ativo')
            })
           
          } else {
            errorAlert(
              error.response.data.error ?? 'Falha ao remover dose cultura!',
              5000,
              'teste'
            )
          }

          throw error
        })
       
    }
  )

  return {
    carregando_remover_dose: mutation.isLoading,
    mutate_remover_dose: mutation.mutate,
    isSuccess_remover_dose: mutation.isSuccess,
  }
}